// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const maintenance = {
  id: "maintenance",
  title: "Maintenance",
  type: "group",
  children: [
    {
      id: "maintenance-schedule",
      title: "Maintenance",
      type: "item",
      url: "/maintenance",
    },
  ],
};

export default maintenance;
